export const medicalReviewer = {
  tag: "Medical reviewer",
};
